var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72498 0.281552C9.58486 0.141112 9.39462 0.0621875 9.19623 0.0621875C8.99784 0.0621875 8.8076 0.141112 8.66748 0.281552L4.99998 3.94155L1.33248 0.274052C1.19235 0.133612 1.00212 0.0546875 0.803728 0.0546875C0.60534 0.0546875 0.415102 0.133612 0.274978 0.274052C-0.017522 0.566552 -0.017522 1.03905 0.274978 1.33155L3.94248 4.99905L0.274978 8.66655C-0.017522 8.95905 -0.017522 9.43155 0.274978 9.72405C0.567478 10.0166 1.03998 10.0166 1.33248 9.72405L4.99998 6.05655L8.66748 9.72405C8.95998 10.0166 9.43248 10.0166 9.72498 9.72405C10.0175 9.43155 10.0175 8.95905 9.72498 8.66655L6.05748 4.99905L9.72498 1.33155C10.01 1.04655 10.01 0.566552 9.72498 0.281552Z",
    fill: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose24Px);
export default __webpack_public_path__ + "static/media/close_24px.8b907289f9378f439b052b1d23048f90.svg";
export { ForwardRef as ReactComponent };